/*
 * ===============================================================================================================
 *                                Copyright 2024, Blue Yonder Group, Inc.
 *                                           All Rights Reserved
 *
 *                               THIS IS UNPUBLISHED PROPRIETARY SOURCE CODE OF
 *                                          BLUE YONDER GROUP, INC.
 *
 *
 *                         The copyright notice above does not evidence any actual
 *                                 or intended publication of such source code.
 *
 * ===============================================================================================================
 */

import { Theme } from "@mui/material";
import { makeStyles } from "@mui/styles";

export const useStyles = makeStyles((theme: Theme) => ({
  root: {
    width: "100%",
    height: "100%",
    display: "flex",
    overflow: "scroll",
    flexDirection: "column",
  },
  searchTextBox: {
    width: "100%",
    "&&&:before": {
      borderBottom: "none",
    },
    "&&:after": {
      borderBottom: "none",
    },
  },
  searchBox: {
    display: "flex",
    width: "100%",
    alignItems: "center",
    padding: theme.spacing(1),
    justifyContent: "space-between",
    backgroundColor: theme.palette.background.default,
  },
  avatarDisplay: {
    marginRight: theme.spacing(2),
  },
  avatarWrapper: {
    minWidth: "auto",
    margin: 0,
  },
  wrappingText: {
    // "& p.MuiTypography-root": {
    //   display: "-webkit-box",
    //   overflow: "hidden",
    //   "-webkit-box-orient": "vertical",
    //   "-webkit-line-clamp": 2,
    // },
  },
  listItem: {
    padding: 0,
    marginTop: theme.spacing(0),
    marginBottom: theme.spacing(0),
    marginLeft: theme.spacing(0),
  },
  loadingContainer: {
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
    height: theme.spacing(30),
  },
  loader: {
    color: theme.palette.primary.main,
  }
}));

export default useStyles;
